import type { PopupBrandColor } from '@onetext/api';

export const brandColors : PopupBrandColor = {
    text:       '#fff',
    background: '#3d3d3d'
};
